import {useState} from "react";
import SidebarLinkGroupLink from "./SidebarLinkGroupLink.jsx";

const KEEP_OPEN = false;

export default function SidebarLinkGroup({group, setSidebarExpanded}) {

    let current = group['is_current'];

    let [opened, setOpened] = useState(current || KEEP_OPEN);

    return (
        <li className={`pl-4 pr-3 py-2 rounded-lg mb-0.5 last:mb-0 ${current && 'bg-[linear-gradient(135deg,var(--tw-gradient-stops))] from-violet-500/[0.12] dark:from-violet-500/[0.24] to-violet-500/[0.04]'}`}>
            <a href="#"
               className={`
                    block text-gray-800 dark:text-white truncate transition duration-150 
                    ${current ? 'hover:text-gray-800 dark:hover:text-white' : 'hover:text-violet-500 dark:hover:text-violet-400'}
               `}
               onClick={(e) => {
                   e.preventDefault();
                   setOpened((!opened) || KEEP_OPEN);
                   setSidebarExpanded(true);
               }}
            >
                <div className="flex items-center justify-between">
                    <div className="ico-text flex items-center">
                        <div className={`icon w-5 text-center ${current ? 'text-violet-500' : 'text-gray-400'}`}>{group['icon']}</div>
                        <span
                            className=" text-sm font-medium ml-2 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
                        >
                            {group['name']}
                        </span>
                    </div>
                    {/* Icon */}
                    {!KEEP_OPEN &&
                        <div className="flex shrink-0 arrow">
                            <svg
                                className={`w-3 h-3 shrink-0 ml-1 fill-current text-gray-400 ${opened && 'rotate-180'}`}
                                viewBox="0 0 12 12"
                            >
                                <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"/>
                            </svg>
                        </div>
                    }
                </div>
            </a>
            <div className="lg:hidden lg:sidebar-expanded:block 2xl:block">
                <ul className={`submenu pl-7 mt-1 ${!opened && 'hidden'}`}>
                    {group['routes'].map((route, index) =>
                        <SidebarLinkGroupLink route={route} key={index + route['name']}/>
                    )}
                </ul>
            </div>
        </li>
    );
}